import React from "react";

export function TreatmentIdentity({ name, code }) {
  return <div className="min-w-[12rem]"><div className="font-medium text-slate-900">{name}</div><div className="mt-0.5 text-xs text-slate-500 break-all">{code}</div></div>;
}

export function formatTreatmentNumber(value) {
  if (value == null || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 10 }).format(number);
}
